import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Modal from '../../../_layout/genericComponents/Modal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import { RiSurveyLine } from "react-icons/ri";

import { getEncuestaCatPregunta, tablaEncuestaCatPreguntas } from '../../../querys/EncuestaCatalogo';
import { upsertEncuestaCatPregunta, deleteEncuestaCatPregunta } from '../../../mutations/EncuestaCatalogo';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import * as Permisos from '../Permisos';
import Opciones from './Opciones';

const { trim } = Validaciones;

export const TiposPregunta = [
    { value: "TITULO", label: "Título (sin respuesta)" },
    { value: "NOTA", label: "Nota (texto informativo sin respuesta)" },
    { value: "TEXTO", label: "Texto (respuesta abierta)" },
    { value: "TEXTO_CORTO", label: "Texto corto (una línea)" },
    { value: "NUMERO", label: "Número" },
    { value: "SI_NO", label: "Sí / No" },
    { value: "OPCIONES", label: "Opciones (se pueden marcar varias)" },
    { value: "ARCHIVO", label: "Archivo adjunto" },
    { value: "TABLA", label: "Tabla" }
];

const TiposDetalle = [
    { value: "TEXTO", label: "Explicación (texto)" },
    { value: "ARCHIVO", label: "Archivo adjunto" }
];

const ModosFilas = [
    { value: "ANIOS", label: "Por año (según el ejercicio de la encuesta)" },
    { value: "FIJAS", label: "Fijas (se capturan en Columnas / Filas)" }
];

// Tipos que no llevan respuesta
const tiposSinRespuesta = ["TITULO", "NOTA"];

function Preguntas({ seccion, accionesUsr }) {

    const { token } = useSelector(state => state.login);
    const { seccionCatID, clave } = seccion;

    const cleanState = {
        preguntaCatID: null,
        seccionCatID,
        orden: "",
        tipo: "",
        texto: "",
        obligatoria: false,
        activa: true,
        etiquetaDetalle: "",
        tipoDetalle: "TEXTO",
        valorDefault: "",
        modoFilas: "ANIOS",
        aniosAtras: "4",
        incluyeProyeccion: false,
        subfilas: ""
    };
    const cleanErrorState = {
        tipo: { error: false, helperText: "" },
        texto: { error: false, helperText: "" },
        orden: { error: false, helperText: "" },
        etiquetaDetalle: { error: false, helperText: "" },
        modoFilas: { error: false, helperText: "" },
        aniosAtras: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [preguntaOpciones, setPreguntaOpciones] = useState(null);

    let titleAccion = state.preguntaCatID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Pregunta — Sección ${clave}`;

    const tipoRef = useRef(null);
    const textoRef = useRef(null);
    const ordenRef = useRef(null);
    const etiquetaDetalleRef = useRef(null);
    const modoFilasRef = useRef(null);
    const aniosAtrasRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "preguntaCatID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getEncuestaCatPregunta,
            formatearResultado: [
                { id: "obligatoria", formato: (data) => Number(data) === 1 },
                { id: "activa", formato: (data) => Number(data) === 1 },
                { id: "incluyeProyeccion", formato: (data) => Number(data) === 1 },
                { id: "tipoDetalle", formato: (data) => data || "TEXTO" },
                { id: "modoFilas", formato: (data) => data || "ANIOS" },
                { id: "aniosAtras", formato: (data) => data === "" ? "4" : String(data) }
            ]
        })
    }, {
        id: "opciones",
        accionID: [1],
        icono: ViewColumnIcon,
        color: success,
        descripcion: "Columnas / Filas / Opciones",
        parametros: [{ campo: "preguntaCatID" }, { campo: "tipo" }, { campo: "modoFilas" }, { campo: "texto" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => setPreguntaOpciones(parametros)
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "preguntaCatID" }, { campo: "orden" }],
        disabled: { multiseleccion: true },
        onClick: ({ preguntaCatID, orden }) => handelAlertEliminar({
            setAlert,
            mensaje: ` la pregunta ${orden} de la sección ${clave}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { preguntaCatID }, asyncDelete: deleteEncuestaCatPregunta
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "preguntaCatID",
        color: primary,
        title: `Preguntas de la Sección ${clave}`,
        title2: seccion.descripcion,
        iconTable: <RiSurveyLine />,
        headers: [
            { variable: "preguntaCatID", descripcion: "preguntaCatID", hide: true },
            { variable: "orden", descripcion: "Orden" },
            { variable: "tipoNombre", descripcion: "Tipo" },
            { variable: "texto", descripcion: "Texto" },
            { variable: "etiquetaDetalle", descripcion: "Explicación / Encabezado" },
            { variable: "opciones", descripcion: "Columnas / Filas / Opciones" },
            { variable: "activaNombre", descripcion: "Activa" },
            { variable: "tipo", descripcion: "tipo", hide: true },
            { variable: "modoFilas", descripcion: "modoFilas", hide: true },
            { variable: "seccionCatID", descripcion: "seccionCatID", hide: true },
            { variable: "clave", descripcion: "clave", hide: true },
            { variable: "obligatoria", descripcion: "obligatoria", hide: true },
            { variable: "activa", descripcion: "activa", hide: true },
            { variable: "tipoDetalle", descripcion: "tipoDetalle", hide: true },
            { variable: "valorDefault", descripcion: "valorDefault", hide: true },
            { variable: "aniosAtras", descripcion: "aniosAtras", hide: true },
            { variable: "incluyeProyeccion", descripcion: "incluyeProyeccion", hide: true },
            { variable: "subfilas", descripcion: "subfilas", hide: true },
            { variable: "fechaModificacion", descripcion: "fechaModificacion", hide: true }
        ],
        responsiveTitle: ["texto"],
        filter: [
            { campo: "texto" }
        ],
        alineacion: [{ columnas: [0, 1, 2, 5, 6], alineacion: "center" }, { columnas: [3, 4], alineacion: "left" }],
        accionesEffect: [{ botones: ["opciones"], ocultar: (data) => !["TABLA", "OPCIONES"].includes(data["tipo"].value) }]
    }

    const esTabla = state.tipo === "TABLA";
    const llevaRespuesta = state.tipo !== "" && !tiposSinRespuesta.includes(state.tipo);

    const inputsPregunta = [
        {
            disabled,
            id: "tipo",
            value: state.tipo,
            error: errorState.tipo.error,
            success: state.tipo && !errorState.tipo.error ? true : undefined,
            helperText: errorState.tipo.helperText,
            inputRef: tipoRef,
            tipo: "select",
            data: TiposPregunta,
            title: "Tipo *",
            placeholder: "Seleccione el tipo",
            grid: { md: 4, lg: 4 },
            onChange: ({ target: { value } }) => handleChange(value, "tipo")
        },
        {
            disabled,
            id: "orden",
            value: state.orden,
            error: errorState.orden.error,
            success: state.orden !== "" && !errorState.orden.error ? true : undefined,
            helperText: errorState.orden.helperText || "Vacío para agregarla al final",
            inputRef: ordenRef,
            title: "Orden",
            placeholder: "Orden en la sección",
            grid: { md: 2, lg: 2 },
            onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "orden"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "activa",
            value: state.activa,
            checked: state.activa,
            title: "Activa",
            tipo: "switch",
            grid: { md: 3, lg: 3 },
            onChange: (e) => handleChange(e.target.checked, "activa")
        },
        llevaRespuesta && {
            disabled,
            id: "obligatoria",
            value: state.obligatoria,
            checked: state.obligatoria,
            title: "Respuesta obligatoria",
            tipo: "switch",
            grid: { md: 3, lg: 3 },
            onChange: (e) => handleChange(e.target.checked, "obligatoria")
        },
        {
            disabled,
            id: "texto",
            value: state.texto,
            error: errorState.texto.error,
            success: state.texto && !errorState.texto.error ? true : undefined,
            helperText: errorState.texto.helperText || (esTabla ? "Opcional: texto que se muestra arriba de la tabla" : "Incluya la numeración, p. ej. \"A) ...\""),
            inputRef: textoRef,
            multiline: true,
            title: esTabla ? "Texto" : "Texto *",
            placeholder: "Capture el texto de la pregunta",
            grid: { md: 12, lg: 12 },
            onChange: ({ target: { value } }) => handleChange(value, "texto"),
            onKeyDown: () => { return; }
        }
    ];

    const inputsDetalle = [];
    if (state.tipo === "SI_NO") {
        inputsDetalle.push({
            disabled,
            id: "tipoDetalle",
            value: state.tipoDetalle,
            tipo: "select",
            data: TiposDetalle,
            title: "Cuando la respuesta es Sí, pedir",
            grid: { md: 4, lg: 4 },
            onChange: ({ target: { value } }) => handleChange(value, "tipoDetalle")
        });
    }
    if (["SI_NO", "OPCIONES", "TABLA"].includes(state.tipo)) {
        let configuracion = {
            SI_NO: { title: "Texto de la explicación", helper: "Vacío si no se pide explicación cuando la respuesta es Sí", grid: 8 },
            OPCIONES: { title: "Texto de la explicación", helper: "Se pide al marcar una opción configurada con \"Pide explicación\"; vacío si no se pide", grid: 12 },
            TABLA: { title: "Encabezado de la columna de filas", helper: "P. ej. \"Año\" o \"Tipo de Mercancia\"", grid: 12 }
        }[state.tipo];
        inputsDetalle.push({
            disabled,
            id: "etiquetaDetalle",
            value: state.etiquetaDetalle,
            error: errorState.etiquetaDetalle.error,
            success: state.etiquetaDetalle && !errorState.etiquetaDetalle.error ? true : undefined,
            helperText: errorState.etiquetaDetalle.helperText || configuracion.helper,
            inputRef: etiquetaDetalleRef,
            multiline: !esTabla,
            title: configuracion.title,
            placeholder: configuracion.title,
            grid: { md: configuracion.grid, lg: configuracion.grid },
            onChange: ({ target: { value } }) => handleChange(value, "etiquetaDetalle"),
            onKeyDown: () => { return; }
        });
    }
    if (["TEXTO", "TEXTO_CORTO", "NUMERO"].includes(state.tipo)) {
        inputsDetalle.push({
            disabled,
            id: "valorDefault",
            value: state.valorDefault,
            title: "Valor inicial",
            placeholder: "Opcional, p. ej. MILLONES DE PESOS",
            grid: { md: 12, lg: 12 },
            onChange: ({ target: { value } }) => handleChange(value, "valorDefault"),
            onKeyDown: () => { return; }
        });
    }
    if (esTabla) {
        inputsDetalle.push({
            disabled,
            id: "modoFilas",
            value: state.modoFilas,
            error: errorState.modoFilas.error,
            helperText: errorState.modoFilas.helperText,
            inputRef: modoFilasRef,
            tipo: "select",
            data: ModosFilas,
            title: "Filas de la tabla *",
            grid: { md: 6, lg: 6 },
            onChange: ({ target: { value } }) => handleChange(value, "modoFilas")
        });
        if (state.modoFilas === "ANIOS") {
            inputsDetalle.push({
                disabled,
                id: "aniosAtras",
                value: state.aniosAtras,
                error: errorState.aniosAtras.error,
                success: state.aniosAtras !== "" && !errorState.aniosAtras.error ? true : undefined,
                helperText: errorState.aniosAtras.helperText || "Filas: N años atrás … Est. cierre año actual",
                inputRef: aniosAtrasRef,
                title: "Años hacia atrás *",
                grid: { md: 3, lg: 3 },
                onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "aniosAtras"),
                onKeyDown: () => { return; }
            }, {
                disabled,
                id: "incluyeProyeccion",
                value: state.incluyeProyeccion,
                checked: state.incluyeProyeccion,
                title: "Incluir fila de proyección (año siguiente)",
                tipo: "switch",
                grid: { md: 3, lg: 3 },
                onChange: (e) => handleChange(e.target.checked, "incluyeProyeccion")
            });
        } else {
            inputsDetalle.push({
                disabled,
                id: "subfilas",
                value: state.subfilas,
                helperText: "Opcional: subdivide cada fila, separadas por |. P. ej. Promedio|Máximo",
                title: "Subfilas",
                placeholder: "Promedio|Máximo",
                grid: { md: 6, lg: 6 },
                onChange: ({ target: { value } }) => handleChange(value, "subfilas"),
                onKeyDown: () => { return; }
            });
        }
    }

    const inputs = [
        {
            id: "Pregunta",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: inputsPregunta.filter(Boolean)
        },
        inputsDetalle.length > 0 && {
            id: "Detalle",
            tipo: "fieldset",
            leyenda: esTabla ? "Configuración de la tabla" : "Configuración de la respuesta",
            grid: { lg: 12 },
            inputs: inputsDetalle
        }
    ].filter(Boolean);

    let accionesFormulario = [{
        accionID: state.preguntaCatID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: tipoRef,
            mensajeCorrecto: `La pregunta se ${state.preguntaCatID ? "actualizó" : "agregó"} correctamente${esTabla && !state.preguntaCatID ? "; agregue sus columnas desde \"Columnas / Filas / Opciones\"" : ""}`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ tipo, texto, modoFilas, aniosAtras }) {

        let error;
        let validaciones = [
            {
                condicion: !tipo,
                ref: tipoRef, keyError: "tipo",
                mensajeError: "Debe seleccionar el tipo de pregunta"
            },
            {
                condicion: tipo !== "TABLA" && (!texto || trim(texto) === ""),
                ref: textoRef, keyError: "texto",
                mensajeError: "Debe especificar el texto de la pregunta"
            },
            {
                condicion: tipo === "TABLA" && !modoFilas,
                ref: modoFilasRef, keyError: "modoFilas",
                mensajeError: "Debe indicar cómo se forman las filas de la tabla"
            },
            {
                condicion: tipo === "TABLA" && modoFilas === "ANIOS" && (aniosAtras === "" || Number(aniosAtras) > 20),
                ref: aniosAtrasRef, keyError: "aniosAtras",
                mensajeError: "Indique de 0 a 20 años hacia atrás"
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let {
                preguntaCatID, orden, tipo, texto, obligatoria, activa, etiquetaDetalle, tipoDetalle, valorDefault,
                modoFilas, aniosAtras, incluyeProyeccion, subfilas
            } = state;

            let error = await handleValidaciones({ tipo, texto, modoFilas, aniosAtras });

            if (error) return error;

            // El servidor descarta los datos que no aplican al tipo de pregunta
            await upsertEncuestaCatPregunta({
                input: {
                    preguntaCatID: preguntaCatID || null,
                    seccionCatID,
                    orden: orden !== "" ? Number(orden) : null,
                    tipo,
                    texto: trim(texto || ""),
                    obligatoria: obligatoria && !tiposSinRespuesta.includes(tipo) ? 1 : 0,
                    activa: activa ? 1 : 0,
                    etiquetaDetalle: trim(etiquetaDetalle || "") || null,
                    tipoDetalle: tipoDetalle || null,
                    valorDefault: trim(valorDefault || "") || null,
                    modoFilas: modoFilas || null,
                    aniosAtras: aniosAtras !== "" ? Number(aniosAtras) : null,
                    incluyeProyeccion: incluyeProyeccion ? 1 : 0,
                    subfilas: trim(subfilas || "") || null
                }
            }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={tablaEncuestaCatPreguntas}
            token={token}
            parametrosFijos={{ seccionCatID }}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={tipoRef}
        />
        {preguntaOpciones && <Modal maxWidth={true} open={true} onClose={() => { setPreguntaOpciones(null); setActualizar(!actualizar); }}>
            <Opciones pregunta={preguntaOpciones} accionesUsr={accionesUsr} />
        </Modal>}
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default Preguntas;
